/**
 * Route prefetch registry.
 *
 * routes/index.jsx registers `path prefix -> [lazy components]` at startup;
 * the sidebar calls preloadRoute(path) on hover/focus and during idle time so
 * a click lands on a chunk that is already downloaded. Kept out of the routes
 * module so the sidebar (which lives inside those chunks) can import it
 * without a cycle.
 */
let registry = {};

export function registerRoutePreloads(map) {
  registry = { ...registry, ...map };
}

export function preloadRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') return;
  const key = Object.keys(registry)
    .filter((p) => pathname === p || pathname.startsWith(p + '/'))
    .sort((a, b) => b.length - a.length)[0];
  if (!key) return;
  registry[key].forEach((c) => c?.preload?.());
}

/* Warm a few chunks when the browser is idle, cheapest first. */
export function preloadWhenIdle(paths, { delay = 1500 } = {}) {
  const run = () => paths.forEach((p) => preloadRoute(p));
  const schedule = () => {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 500);
  };
  const t = setTimeout(schedule, delay);
  return () => clearTimeout(t);
}
